<template>
  <div class="f-row h-100">
    <div class="col col-12 text-center h-100" style="width:100%;">
      <div class="row f-row" v-show="showTitles">
        <div class="col col-12 chart-title">
          Step 2: Create Strategies Based on Indicative Quotes
        </div>
      </div>
      <div
        class="row f-row justify-content-center mt-2"
        style="font-size: 0.8rem; height: 1rem;"
      >
        <div class="col col-auto ml-1">
          <span class="inline-ul mr-1"
            >Weekly {{ showTitles ? "Candles" : "" }} Up/Dwn</span
          >
          <div class="triangle-topleft-active"></div>
        </div>
        <div class="col col-auto ml-1">
          <button class="btn detailView">
            Mid market
            {{
              fwdName.charAt(0).toUpperCase() + fwdName.slice(1).toLowerCase()
            }}
            <i class="fa fa-minus" style="color:var(--textactive)"></i>
          </button>
        </div>
        <div class="col col-auto ml-1">
          <button class="btn detailView" v-on:click="onShow(5)">
            {{ showTitles ? "+Forwards / Futures" : "+Fwd/Fut" }}
            <img :src="lFwd" height="16" alt="" />
          </button>
        </div>
        <div class="col col-auto ml-1">
          <button class="btn detailView" v-on:click="onShow(6)">
            {{ showTitles ? "-Forwards / Futures" : "-Fwd/Fut" }}
            <img :src="sFwd" height="16" alt="" />
          </button>
        </div>
        <div class="col col-auto ml-1">
          <div class="img-v-align">
            <button class="btn detailView" v-on:click="onShow(7)">
              +Call
              <img :src="lCall" height="16" alt="" />
            </button>
          </div>
        </div>
        <div class="col col-auto ml-1">
          <div class="img-v-align">
            <button class="btn detailView" v-on:click="onShow(8)">
              -Call
              <img :src="sCall" height="16" alt="" />
            </button>
          </div>
        </div>
        <div class="col col-auto ml-1">
          <div class="img-v-align">
            <button class="btn detailView" v-on:click="onShow(9)">
              +Put
              <img :src="lPut" height="16" alt="" />
            </button>
          </div>
        </div>
        <div class="col col-auto ml-1">
          <div class="img-v-align">
            <button class="btn detailView" v-on:click="onShow(10)">
              -Put
              <img :src="sPut" height="16" alt="" />
            </button>
          </div>
        </div>
      </div>
      <div
        class="row f-row justify-content-center"
        v-bind:class="[
          showTitles ? 'strat-designer-height-1' : 'strat-designer-height-2',
        ]"
      >
        <div class="col col-4 h-100">
          <HistoricalChart
            :candleData="historicalData"
            :colorTheme="colorTheme"
            :controlsSpace="false"
            :dateFormat="dateFormatHist"
            :includeLine="true"
            :minMaxYAxis="minMaxYAxisRates"
            :renderChartSignal="renderCharts"
            :showLoading="
              showLoadingHistCandles || showLoading || showLoadingSpot
            "
            :showOHL="showOHL"
            :title="'WEEKLY'"
            :zeroRequests="false"
          />
        </div>
        <div class="col col-7 h-100">
          <RatesChart
            :adjustTooltip="adjustTooltip"
            :averages="[]"
            :budgetRate="[]"
            :candleData="[]"
            :chartData="dataSliced"
            :colorTheme="colorTheme"
            :controlsSpace="false"
            :currency="baseCurrency"
            :dateFormat="'%b %y'"
            :derivativeAverages="[]"
            :derivativeDateField="'date'"
            :hedgeData="hedgeData"
            :historicalData="historicalData"
            :isFuture="true"
            :minMaxYAxis="minMaxYAxisRates"
            :renderChartSignal="renderCharts"
            :showAve="false"
            :showBudget="false"
            :showExpo="false"
            :showHedge="false"
            :showLCall="showLCall"
            :showLFwd="showLFwd"
            :showLoading="
              showLoadingHistCandles || showLoading || showLoadingSpot
            "
            :showLPut="showLPut"
            :showMkt="true"
            :showNet="false"
            :showSCall="showSCall"
            :showSFwd="showSFwd"
            :showSimulations="false"
            :showSPut="showSPut"
            :showTooltip="false"
            :showTooltipDeriv="true"
            :simulations="[]"
            :xRange="xRange"
            :asset="asset"
            :zeroRequests="false"
          />
        </div>
      </div>
    </div>
    <div
      class="carousel-caption d-none d-md-block mb-2 txt-carrousel-bottom"
      v-if="showTitles"
    >
      Step 2: Create Strategies Based on Indicative Quotes
    </div>
  </div>
</template>

<script>
import HistoricalChart from "@/components/advanced/HistoricalChart.vue";
import RatesChart from "@/components/advanced/RatesChart.vue";

export default {
  name: "StrategiesDesigner",
  components: {
    HistoricalChart,
    RatesChart,
  },
  props: {
    adjustTooltip: { required: false, type: Boolean, default: false },
    baseCurrency: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
    dataSliced: { required: true, default: () => [] },
    hedgeData: { required: true, default: () => [] },
    historicalData: { required: true, default: () => [] },
    minMaxYAxisRates: { required: true },
    renderCharts: { required: true },
    selectedAssetLink: { required: true },
    showLCall: { required: true },
    showLFwd: { required: true },
    showLoading: { required: true, type: Boolean, default: false },
    showLoadingHistCandles: { required: true, type: Boolean, default: false },
    showLoadingSpot: { required: false, type: Boolean, default: false },
    showLPut: { required: true },
    showOHL: { required: false, type: Boolean, default: true },
    showSCall: { required: true },
    showSFwd: { required: true },
    showSPut: { required: true },
    showTitles: { required: false, type: Boolean, default: true },
    strategies: { required: true },
    xRange: { required: true },
    asset: { required: false, default: "currencies" },
  },
  data() {
    return {
      dateFormatHist: "%d %b %y",

      // ================ imports ===================
      lCall: require("@/assets/images/lCall.svg"),
      lCallOff: require("@/assets/images/derivUpOff.svg"),
      lCallOn: require("@/assets/images/lCall.svg"),
      lFwd: require("@/assets/images/lFwd.svg"),
      lFwdOff: require("@/assets/images/fwdUpOff.svg"),
      lFwdOn: require("@/assets/images/lFwd.svg"),
      lPut: require("@/assets/images/lPut.svg"),
      lPutOff: require("@/assets/images/derivUpOff.svg"),
      lPutOn: require("@/assets/images/lPut.svg"),
      sCall: require("@/assets/images/sCall.svg"),
      sCallOff: require("@/assets/images/derivDownOff.svg"),
      sCallOn: require("@/assets/images/sCall.svg"),
      sFwd: require("@/assets/images/sFwd.svg"),
      sFwdOff: require("@/assets/images/fwdDownOff.svg"),
      sFwdOn: require("@/assets/images/sFwd.svg"),
      sPut: require("@/assets/images/sPut.svg"),
      sPutOff: require("@/assets/images/derivDownOff.svg"),
      sPutOn: require("@/assets/images/sPut.svg"),
    };
  },
  computed: {
    fwdName() {
      return this.selectedAssetLink === 0 ? "FORWARDS" : "SWAPS";
    },
  },
  watch: {
    showLCall(val) {
      this.lCall = val === true ? this.lCallOn : this.lCallOff;
    },
    showSCall(val) {
      this.sCall = val === true ? this.sCallOn : this.sCallOff;
    },
    showLFwd(val) {
      this.lFwd = val === true ? this.lFwdOn : this.lFwdOff;
    },
    showSFwd(val) {
      this.sFwd = val === true ? this.sFwdOn : this.sFwdOff;
    },
    showLPut(val) {
      this.lPut = val === true ? this.lPutOn : this.lPutOff;
    },
    showSPut(val) {
      this.sPut = val === true ? this.sPutOn : this.sPutOff;
    },
  },
  methods: {
    onShow(idx) {
      this.$emit("eventOnShow", idx);
    },
  },
};
</script>
